import { writable, derived } from 'svelte/store';
import { apiService } from '../services/api';
function createAuthStore() {
    const { subscribe, set, update } = writable({
        initialized: false,
        loading: false,
        authenticated: false,
        user: null,
        error: null,
    });
    return {
        subscribe,
        /**
         * Initialize auth state by checking current session
         */
        async initialize() {
            update(state => (Object.assign(Object.assign({}, state), { loading: true, error: null })));
            try {
                const status = await apiService.getAuthStatus();
                set({
                    initialized: true,
                    loading: false,
                    authenticated: status.authenticated,
                    user: status.user,
                    error: null,
                });
            }
            catch (error) {
                console.error('Auth initialization failed:', error);
                set({
                    initialized: true,
                    loading: false,
                    authenticated: false,
                    user: null,
                    error: error instanceof Error ? error.message : 'Auth check failed',
                });
            }
        },
        /**
         * Redirect to login page
         */
        login(returnUrl) {
            const loginUrl = apiService.getLoginUrl(returnUrl || window.location.href);
            window.location.href = loginUrl;
        },
        /**
         * Log out and clear state
         * If IdP logout URL is returned, redirect to it for full SSO logout
         */
        async logout() {
            update(state => (Object.assign(Object.assign({}, state), { loading: true })));
            try {
                const result = await apiService.logout();
                // Clear local state first
                set({
                    initialized: true,
                    loading: false,
                    authenticated: false,
                    user: null,
                    error: null,
                });
                // Redirect to IdP logout if URL is provided (for full SSO logout)
                if (result.idp_logout_url) {
                    window.location.href = result.idp_logout_url;
                }
            }
            catch (error) {
                console.error('Logout failed:', error);
                // Still clear local state even if logout request fails
                set({
                    initialized: true,
                    loading: false,
                    authenticated: false,
                    user: null,
                    error: null,
                });
            }
        }
    };
}
export const authStore = createAuthStore();
// Derived stores for convenience
export const isAuthenticated = derived(authStore, $auth => $auth.authenticated);
export const currentUser = derived(authStore, $auth => $auth.user);
export const authLoading = derived(authStore, $auth => $auth.loading);
export const authInitialized = derived(authStore, $auth => $auth.initialized);
